import { Apis } from "./index";


class ApiMonitorHistory {

    static summary({
        homeId,
        start,
        end
    }) {
        return Apis
            .get(`/api/monitor-history/${homeId}/summary/month?startDate=${start}&endDate=${end}`);
    }

}

export { ApiMonitorHistory };